import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { AbTestGroupUserInputType } from '@/gql/graphql';

export const createAbTestGroupUser = async (data: AbTestGroupUserInputType) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation CreateAbTestGroupUser($data: AbTestGroupUserInputType!) {
        createAbTestGroupUser(data: $data) {
          id
          userId
          abTestGroupId
          associatedObjectType
          associatedObjectId
          isActive
          abTestId
        }
      }
    `),
  });

  return response.data?.createAbTestGroupUser;
};
